import { SURE_CARE } from 'core/constants/products'
import isPlanType from 'utils/pivot/plan/isPlanType'

function isSureCarePlan<T extends CorePlan>(plan: T): boolean {
  return isPlanType(plan, SURE_CARE)
}

export default isSureCarePlan
